// @TODO <HEALTH2019>
App.factory('healthInsuranceService', ['$q', 'baseService', 'Config', 'healthInsuranceSharedService', function($q, baseService, Config, healthInsuranceSharedService) {
    function HealthInsuranceService() {

        this.sendInformationDocuments = function() {
            return baseService.post(Config.API_URL + '/healthInsuranceDeclaration/informationDocuments', {});
        };

        this.getStatement = function(uuid) {
            return baseService.download(Config.API_URL + '/healthInsuranceDeclaration/' + uuid + '/statement').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getDeclaration = function(uuid) {
            return baseService.download(Config.API_URL + '/healthInsuranceDeclaration/' + uuid + '/declaration').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
        this.getDeclarations = function(data) {
            return baseService.post(Config.API_URL + '/healthInsuranceDeclaration/list', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            }).then(function (data) {
                if (data.status === 200) {
                    var newData = [];
                    data.data.data.forEach(function (single) {
                        newData.push(healthInsuranceSharedService.convertFromHealth(single));
                    });

                    data.data.data = newData;
                }

                return data;
            });
        };
        this.getLastDeclaration = function (insurer) {
            return baseService.get(`${Config.API_URL}/healthInsuranceDeclaration/last?insurer=${insurer}`).then(function (success) {
                return success;
            }, function (error) {
                return error;
            }).then(function (data) {
                data.data = healthInsuranceSharedService.convertFromHealth(data.data);
                return data;
            });
        };
        this.getLastActiveDeclaration = function (insurer) {
            return baseService.get(`${Config.API_URL}/healthInsuranceDeclaration/lastActive?insurer=${insurer}`).then(function (success) {
                return success;
            }, function (error) {
                return error;
            }).then(function (data) {
                data.data = healthInsuranceSharedService.convertFromHealth(data.data);
                return data;
            });
        };
        this.add = function(data, isPartnerTypeDeclaration) {
            isPartnerTypeDeclaration = isPartnerTypeDeclaration || false;
            data = healthInsuranceSharedService.convertToHealth(data, isPartnerTypeDeclaration);
            return baseService.post(Config.API_URL + '/healthInsuranceDeclaration/save', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

    }
    return new HealthInsuranceService();
}]);
// @TODO </HEALTH2019>
